<template>
  <div class="home">
    <main-navigation animation />
    <div style="min-height:400px">
      <router-view />
    </div>
    <footer-navigation animation />
    <location-dialog :suggested="suggested" v-model="showLocationDialog" />
  </div>
</template>

<script>
import RegionRouter from '@/mixins/RegionRouter.js'

export default {
  mixins: [RegionRouter],
  mounted () {
    document.getElementsByTagName('body')[0].setAttribute('class','charcoal')
  },
  beforeDestroy () {
    document.getElementsByTagName('body')[0].removeAttribute('class')
  }
}
</script>
<style>
body.charcoal{
  background-color:#000;
}
.charcoal .home {
  background-color:#333;
  color:#fff;
}

.charcoal .fullwidth{
  background-color:#333;
  color:#fff;
}

.charcoal .fullwidth.darker{
  background-color:#4a4f54;
}

.charcoal h2.home-h2{
  color:#efefef;
}

.charcoal .stn-home .style-news-headers h3{
  color:#efefef;
}

.charcoal .style-browser .h2{
  color:#fff;
}

.charcoal .home-about-item h3{
  color:#efefef;
}

.charcoal .testimonials-panel{
  background-color:rgba(16,24,32,0.95);
}

.charcoal .testimonial-holder .close-box{
  background-image:url('../assets/img/close-white.svg');
}

.charcoal .style-browser a{
  color:#ddd;
}

.charcoal .style-browser a:hover{
  color:#ce0e2d;
}

.charcoal .aa-top h2{
  color:#fff;
}

.charcoal .greybar{
  color:#333;
}

.charcoal .news-square{
  color:#333;
}

.charcoal .pf-main h3{
  color:#999;
}

.charcoal .home .slide-overlay{
  color:#000;
}

.charcoal .zoom-flex.inpage h3 a{
  color:#fff;
}
</style>
